/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { EmbeddedTelemetryViewer } from '@/components/EmbeddedTelemetryViewer/EmbeddedTelemetryViewer';

export type TelemetryBetaPageProps = {
  adminMode?: boolean;
};

export function TelemetryBetaPage({ adminMode = false }: TelemetryBetaPageProps) {
  return <EmbeddedTelemetryViewer adminMode={adminMode} />;
}
